module.exports = __webpack_public_path__ + "img/logo.a438425f.png";